<template>
    <div class="lb-card-comments" @click.stop>
        <app-message-input-bar
            v-if="!creationDisabled"
            class="py-1 lb-fixed-bottom-input"
            @comment="sendComment"
            :has-editor="hasEditor"
            :suggestions="suggestions"
        />
        <div class="lb-comments-list">
            <p
                v-if="filteredComments.length > commentsToRender.length"
                class="
                    has-text-weight-bold
                    has-text-primary
                    has-text-centered
                    has-cursor-pointer
                "
                href
                @click="$emit('loadOldComments')"
            >
                {{ $t('Object.view_older_comments') }} ({{ comments.length }})
            </p>
            <div
                v-for="comment in commentsToRender"
                :key="comment._id"
                :ref="comment._id"
                :class="{
                    'has-background-light': comment.sending,
                    'has-background-danger': comment.error,
                    'has-background-danger-light': comment.deleted,
                }"
            >
                <comment
                    :editionDisabled="editionDisabled"
                    :comment="comment"
                    :object="object"
                    :has-editor="hasEditor"
                    @edit="editComment(comment)"
                    @delete="deleteComment(comment)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import AppMessageInputBar from '@/components/AppMessageInputBar';
import ObjectCardComment from '@/components/ObjectCardComment';
import { addComment, updateComment, deleteComment } from '@/services/API';
import _ from 'underscore';
const nanoid = require('nanoid');
export default {
    components: {
        AppMessageInputBar,
        comment: ObjectCardComment,
    },
    filters: {},
    props: {
        comments: {
            type: Array,
            default: () => {
                return [];
            },
        },
        object: {
            type: Object,
            default: () => {
                return {};
            },
        },
        renderAll: {
            type: Boolean,
            default: false,
        },
        modelRelated: {
            type: String,
            default: () => {
                return 'object';
            },
        },
        hasEditor: {
            type: Boolean,
            default: false,
        },
        suggestions: {
            type: Array,
            default: () => {
                return [];
            },
        },
        creationDisabled: {
            type: Boolean,
            default: false,
        },
        editionDisabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        hasTextWritten() {
            return this.message && this.message.length;
        },
        commentsToRender() {
            if (this.renderAll) {
                return this.filteredComments;
            }
            return this.filteredComments.slice(0, 4);
        },
        filteredComments() {
            /*console.log(
                _.filter(this.comments, (comment) => {
                    return comment.deleted == false;
                })
            );*/
            return _.filter(this.comments, (comment) => {
                return comment.deleted == false;
            });
        },
    },
    methods: {
        sendComment(text) {
            let message = {
                localId: nanoid(5),
                message: text,
                owner: this.$store.getters.user,
                created: Date.now(),
                sending: true,
            };
            this.comments.unshift(message); //TODO: move to a local reference because comments is a prop and is immutable, could lead to a wrong behaviour
            addComment(this.modelRelated, this.object._id, {
                message: text,
            })
                .then((result) => {
                    let commentIndex = _.findIndex(this.comments, {
                        localId: message.localId,
                    });
                    this.comments.splice(commentIndex, 1, result.data);
                })
                .catch((e) => {
                    message.error = true;
                    console.log('error', e);
                })
                .finally(() => {
                    message.sending = false;
                });
        },
        updateComment(comment) {
            updateComment(this.modelRelated, this.object._id, comment)
                .then((result) => {
                    let commentIndex = _.findIndex(this.comments, {
                        _id: result.data._id,
                    });
                    this.comments.splice(commentIndex, 1, result.data);
                    // comment = result.data;
                })
                .catch((e) => {
                    console.log('error', e);
                })
                .finally(() => {});
        },

        editComment(comment) {
            this.updateComment(comment);
        },
        deleteComment(comment) {
            deleteComment(this.modelRelated, this.object._id, comment._id)
                .then(({ data }) => {
                    let commentIndex = _.findIndex(this.comments, {
                        _id: data._id,
                    });
                    this.comments.splice(commentIndex, 1, data);
                })
                .finally(() => {
                    console.log('after delete commnet');
                });
        },

        scrollToItem() {
            const lastMessage = _.first(this.comments);
            if (lastMessage) {
                this.$nextTick(() => {
                    this.$refs[lastMessage._id][0].scrollIntoView();
                });
            }
        },
    },
};
</script>

<style scoped>
.lb-card-comments {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.lb-comments-list {
    box-sizing: border-box;
}
.lb-fixed-bottom-input {
    position: relative;
}

.lb-modal-comments .lb-comments-list {
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 5px;
}

@keyframes fly-in {
    0% {
        transform: scale(0.85) translateY(10%);
        opacity: 0;
    }
    100% {
        transform: scale(1) translateY(0);
        opacity: 1;
    }
}

.lb-card-comments /deep/.lb-grow {
    min-height: 2rem;
    max-height: fit-content;
    border-color: transparent;
}
</style>
